import { Checkbox } from "antd";
import React from "react";

interface CheckboxProps {
  checked: boolean;
  onChange: any;
  id: string;
  labelName: string;
  className?: string;
  inputName: string;
  onBlur?: any;
  layout?: "col" | "inline";
}

export const CheckBox: React.FC<CheckboxProps> = ({
  checked,
  id,
  inputName,
  labelName,
  className,
  onChange,
  layout = "col",
}) => {
    const layoutClass =
        layout === "inline"
            ? "d-inline-flex align-items-center"
            : "col d-flex align-items-center";
  return (
    // <div className={`d-inline-flex align-items-center ${className}`}>
      <div className={`${layoutClass} ${className}`}>
      <label
        htmlFor={inputName}
        className="form-label"
        style={{
          marginLeft: "0.5rem", // Ensures label is spaced from the checkbox
        }}
      >
        {labelName}
      </label>
      <Checkbox
        checked={checked}
        name={inputName}
        onChange={onChange}
        id={id}
        style={{
          marginRight: "0.5rem", // Adds space to the right of the checkbox
          width: "auto",
        }}
      />
    </div>
  );
};
